import React from 'react';
import { motion } from 'framer-motion';

const FRONTEND_SKILLS = ['JavaScript', 'React', 'Jquery', 'LESS', 'CSS3', 'Oracle APEX', 'Tailwind CSS'];
const BACKEND_SKILLS = ['Oracle Database', 'MySQL', 'Python', 'MongoDB', 'Solidity', 'PL/SQL'];

const Skills = () => {
  return (
    <section id="Skills" className="section-wrap">
      <div className="section-header">
        <p className="eyebrow">Core Skills</p>
        <h2 className="section-title">Frontend & Backend</h2>
      </div>

      <div className="skills-grid">
        {[{ title: 'Frontend', skills: FRONTEND_SKILLS }, { title: 'Backend', skills: BACKEND_SKILLS }].map(
          (group, index) => (
            <motion.article
              key={group.title}
              className="skills-card"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: index * 0.08, ease: 'easeOut' }}
              viewport={{ once: true, amount: 0.25 }}
            >
              <h3>{group.title}</h3>
              <div className="skill-pill-wrap">
                {group.skills.map((skill) => (
                  <span className="skill-pill" key={`${group.title}-${skill}`}>
                    {skill}
                  </span>
                ))}
              </div>
            </motion.article>
          )
        )}
      </div>
    </section>
  );
};

export default Skills;
